// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__rQkFH","footer":"styles_footer__2531l"};